<template>
    <div class="investor-contact">
        <div class="banner-wrap">
            <div class="title">{{ contact.title }}</div>
            <img class="banner" :src="contact.mobileBanner.url" :alt="contact.title" />
        </div>
        <index-bar :bars="indexBar"></index-bar>

        <div class="content">
            <div :id="indexBar[0]" class="title-wrap">{{ contact.iframe.title }}</div>

            <ul class="contact-info">
                <li><img class="icon" src="@/assets/images/investorRelation/phone.png" alt="phone" />{{ contact.phone }}</li>
                <li><img class="icon" src="@/assets/images/investorRelation/mail.png" alt="mail" />{{ contact.mail }}</li>
            </ul>
            <p class="notes" v-html="contact.content"></p>
            <div class="content-wrap">
                <iframe :src="contact.iframe.url" frameborder="0" width="100%" height="804px"></iframe>
            </div>

            <div :id="indexBar[1]" class="title-wrap">
                {{ brokerage.title }}<span class="sub-title">{{ brokerage.companyTitle }}</span>
            </div>
            <div class="name-list">
                <info-box-component v-for="item in brokerage.list" :key="item.name" :item="item" :ban="true">
                    <div slot="name-slot">{{ item.name }}</div>
                    <div slot="title-slot">{{ item.companyName }}</div>
                    <div slot="title-des-slot">{{ item.companyName }}</div>
                    <div slot="des-slot" v-html="item.description"></div>
                </info-box-component>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import infoBoxComponent from './components/info-box.vue'
import indexBar from './components/index-bar.vue'

export default {
    name: 'InvestorContact',
    components: {
        infoBoxComponent,
        indexBar
    },
    data() {
        return {
            contact: {},
            brokerage: {},
            indexBar: []
        }
    },
    computed: {},
    created() {
        ajax.investorContact().then(res => {
            this.contact = res
        })
        ajax.investorBrokerage().then(res => {
            this.brokerage = res
        })
        ajax.getHomeMenus().then(homeRes => {
            const { menus = [] } = homeRes
            const investorRelationItem = menus.find(i => i.key === 'investorRelation')
            const { children } = investorRelationItem
            const bars = children.find(i => i.key === 'investorContact')
            this.indexBar = bars.indexBar
        })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.investor-contact {
    .banner-wrap {
        height: 480px;
        position: relative;
        .title {
            font-weight: 500;
            font-size: 60px;
            color: #ffffff;
            position: absolute;
            left: 40px;
            top: 80px;
        }
        .banner {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
    .content {
        padding: 0 40px 0 40px;
        .notes {
            margin: 0px auto 40px;
            color: #333333;
            line-height: 150%;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
        }
        .contact-info li {
            .icon {
                width: 36px;
                height: 36px;
                margin-right: 20px;
                vertical-align: middle;
            }
            color: #333333;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
            font-size: 28px;
            line-height: 150%;
            margin-bottom: 30px;
        }
        .title-wrap {
            font-weight: 500;
            font-size: 42px;
            color: #333333;
            margin-bottom: 40px;
            margin-top: 60px;
            .sub-title {
                font-weight: 400;
                font-size: 24px;
                color: #b3b3b3;
                margin-left: 10px;
            }
        }
        .content-wrap {
            margin-bottom: 60px;
        }
        .des {
            font-weight: 400;
            font-size: 26px;
            color: #b3b3b3;
        }
        .name-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/investor-contact.vue